import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-dc-teal-deep/5 pt-16 pb-12 px-6 mt-16">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="max-w-5xl mx-auto flex flex-col items-center justify-center text-center"
      >
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 md:gap-12 mb-8">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/0a403d9f789eedbce54920bff50e3bb7.png" 
            alt="Digital Cowboy" 
            className="h-14 md:h-16 object-contain" 
          />
          <span className="text-dc-teal-deep/20 hidden sm:block text-2xl font-light">|</span>
          <img 
            src="https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/72d2508c2498c1755558cb43ced92309.png" 
            alt="RepUpgrade" 
            className="h-10 md:h-12 object-contain drop-shadow-sm" 
          />
        </div>
        
        <p className="text-dc-text/80 text-sm md:text-base font-medium flex items-center justify-center flex-wrap gap-x-1.5 leading-loose max-w-2xl mx-auto">
          <span>Made with the frequency of</span>
          <span className="text-red-500 mx-0.5" aria-label="love">❤️</span>
          <span>and AI</span>
          <span className="text-dc-gold-1 mx-0.5" aria-label="sparkles">✨</span>
          <a href="https://digitalcowboy.io" target="_blank" rel="noopener noreferrer" className="text-dc-teal-deep hover:text-dc-teal-signal transition-colors font-semibold ml-1">
            digitalcowboy.io
          </a>
          <span className="text-dc-text/50 mx-1">by</span>
          <a href="https://repupgrade.com" target="_blank" rel="noopener noreferrer" className="text-dc-gold-2 hover:text-dc-gold-1 transition-colors font-semibold">
            repupgrade.com
          </a>
        </p>
      </motion.div>
    </footer>
  );
};

export default Footer;